'use client';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { type Session } from 'next-auth';
import { signOut } from 'next-auth/react';
import Image from 'next/image';

export interface UserMenuProps {
    user: Session['user'];
    showIconOnly?: boolean;
}

function getUserInitials(name: string) {
    const [firstName, lastName] = name.split(' ');
    return lastName ? `${firstName[0]}${lastName[0]}` : firstName.slice(0, 2);
}

export function UserMenu({ user }: UserMenuProps) {
    return (
        <div className="mr-2 flex items-center justify-between">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="ghost" className="">
                        {user?.image ? (
                            <>
                                <Image
                                    className="block h-6 w-6 select-none rounded-full ring-1 ring-zinc-100/10 transition-opacity duration-300 hover:opacity-80 sm:hidden"
                                    src={user?.image ? `${user.image}` : ''}
                                    width={24}
                                    height={24}
                                    alt={user.name ?? 'Avatar'}
                                />
                                <span className="hidden sm:block">
                                    {user?.name}
                                </span>
                            </>
                        ) : (
                            <span className="">{user?.name}</span>
                        )}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    sideOffset={8}
                    align="start"
                    className="w-[180px]"
                >
                    <DropdownMenuItem className="flex flex-row items-start">
                        {user?.image ? (
                            <Image
                                className="h-6 w-6 select-none rounded-full ring-1 ring-zinc-100/10 transition-opacity duration-300 hover:opacity-80"
                                src={user?.image ? `${user.image}` : ''}
                                width={24}
                                height={24}
                                alt={user.name ?? 'Avatar'}
                            />
                        ) : (
                            <div className="flex h-7 w-7 shrink-0 select-none items-center justify-center rounded-full bg-muted/50 text-xs font-medium uppercase text-muted-foreground">
                                {user?.name
                                    ? getUserInitials(user?.name)
                                    : null}
                            </div>
                        )}
                        <div className="ml-2 flex flex-col">
                            <div className="text-xs font-medium">
                                {user?.name}
                            </div>
                            <div className="text-xs text-zinc-500">
                                {user?.email}
                            </div>
                        </div>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    {/* <DropdownMenuItem asChild>
						<a
							href="https://vercel.com"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-flex w-full items-center justify-between text-xs"
						>
							Vercel App
							<IconExternalLink className="ml-auto h-3 w-3" />
						</a>
					</DropdownMenuItem> */}
                    <DropdownMenuItem
                        onClick={() =>
                            signOut({
                                callbackUrl: '/'
                            })
                        }
                        className="text-xs"
                    >
                        Log Out
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
